const FORM_CONFIG = {
  newsletter: {
    form_name: "Newsletter subscription",
    emailTempUser: "newsletter_user",
    emailTempAdmin: "newsletter_admin",
    emailSubjectUser: "Thank you for subscribing",
    emailSubjectAdmin: "Newsletter subscription",
    eventTracking: "newsletter",
  },
  event: {
    form_name: "Event - Register Intrest",
    emailTempUser: "event_user",
    emailTempAdmin: "event_admin",
    emailSubjectUser: "Event - Register Intrest",
    emailSubjectAdmin: "Event Register",
    eventTracking: "event",
  },
  openhouse: {
    form_name: "Open House - Register Intrest",
    emailTempUser: "open_house_user",
    emailTempAdmin: "open_house_admin",
    emailSubjectUser: "Open House - Register Intrest",
    emailSubjectAdmin: "Open House Register",
    eventTracking: "open_house",
  },
  branded: {
    form_name: "Branded Projects",
    emailTempUser: "branded_user",
    emailTempAdmin: "branded_admin",
    emailSubjectUser: "Branded Projects",
    emailSubjectAdmin: "Branded Projects",
    eventTracking: "branded",
  },
  ethnovate: {
    form_name: "Ethnovate",
    emailTempUser: "ethnovate_user",
    emailTempAdmin: "ethnovate_admin",
    emailSubjectUser: "Ethnovate",
    emailSubjectAdmin: "Ethnovate",
    eventTracking: "ethnovate",
  },
  brochure: {
    form_name: "Brochure Download",
    emailTempUser: "brochure_user",
    emailTempAdmin: "brochure_admin",
    emailSubjectUser: "Thank you for downloading the brochure",
    emailSubjectAdmin: "Brochure Download",
    eventTracking: "brochure",
  },
  teamContact: {
    form_name: "Team Contact",
    emailTempUser: "team_contact_user",
    emailTempAdmin: "team_contact_admin",
    emailSubjectUser: "Your recent enquiry",
    emailSubjectAdmin: "Team Contact",
    eventTracking: "Team Contact",
  },
  download: {
    form_name: "Download Report",
    emailTempUser: "download_report_user",
    emailTempAdmin: "download_report_admin",
    emailSubjectUser: "Download Report",
    emailSubjectAdmin: "Download Report",
    eventTracking: "Download Report",
  },
  e_book: {
    form_name: "Download eBook",
    emailTempUser: "download_eBook_user",
    emailTempAdmin: "download_eBook_admin",
    emailSubjectUser: "Download eBook",
    emailSubjectAdmin: "Download eBook",
    eventTracking: "Download eBook",
  },
  officeContact: {
    form_name: "Office Contact",
    emailTempUser: "office_contact_user",
    emailTempAdmin: "office_contact_admin",
    emailSubjectUser: "Your recent enquiry",
    emailSubjectAdmin: "Office Contact",
    eventTracking: "Office Contact",
  },
  generalEnquiry: {
    form_name: "General Enquiry",
    emailTempUser: "enquiry_user",
    emailTempAdmin: "enquiry_admin",
    emailSubjectUser: "Your recent enquiry",
    emailSubjectAdmin: "General Enquiry",
    eventTracking: "General Enquiry",
  },
  partnerProgram: {
    form_name: "Partner Program",
    emailTempUser: "partner_user",
    emailTempAdmin: "partner_admin",
    emailSubjectUser: "Your recent enquiry - Partner Program",
    emailSubjectAdmin: "Partner Program",
    eventTracking: "Partner Program",
  },
  propertyMangement: {
    form_name: "Property Management",
    emailTempUser: "property_management_user",
    emailTempAdmin: "property_management_admin",
    emailSubjectUser: "Your recent enquiry - Property Management",
    emailSubjectAdmin: "Property Management",
    eventTracking: "Property Management",
  },
  shortTerm: {
    form_name: "Short Term Rentals",
    emailTempUser: "short_term_rentals_user",
    emailTempAdmin: "short_term_rentals_admin",
    emailSubjectUser: "Your recent enquiry - Short Term Rentals",
    emailSubjectAdmin: "Short Term Rentals",
    eventTracking: "Short Term Rentals",
  },
  mortagage: {
    form_name: "Mortgage",
    emailTempUser: "mortgage_user",
    emailTempAdmin: "mortgage_admin",
    emailSubjectUser: "Your recent enquiry - Mortgage",
    emailSubjectAdmin: "Mortgage",
    eventTracking: "Mortgage",
  },
  snagging: {
    form_name: "Snagging",
    emailTempUser: "snagging_user",
    emailTempAdmin: "snagging_admin",
    emailSubjectUser: "Your recent enquiry - Snagging",
    emailSubjectAdmin: "Snagging",
    eventTracking: "Snagging",
  },
  complaintsProcedure: {
    form_name: "Complaints Procedure",
    emailTempUser: "complaints_procedure_user",
    emailTempAdmin: "complaints_procedure_admin",
    emailSubjectUser: "Complaints Procedure",
    emailSubjectAdmin: "Complaints Procedure",
    eventTracking: "Complaints Procedure",
  },
  conveyancing: {
    form_name: "Conveyancing",
    emailTempUser: "conveyancing_user",
    emailTempAdmin: "conveyancing_admin",
    emailSubjectUser: "Your recent enquiry - Conveyancing",
    emailSubjectAdmin: "Conveyancing",
    eventTracking: "Conveyancing",
  },
  propertyLeasing: {
    form_name: "Property Leasing",
    emailTempUser: "propertyLeasing_user",
    emailTempAdmin: "propertyLeasing_admin",
    emailSubjectUser: "Your recent enquiry - Property Leasing",
    emailSubjectAdmin: "Property Leasing",
    eventTracking: "Property Leasing",
  },
  prism: {
    form_name: "Prism",
    emailTempUser: "prism_user",
    emailTempAdmin: "prism_admin",
    emailSubjectUser: "Your recent enquiry - Prism",
    emailSubjectAdmin: "Prism",
    eventTracking: "Prism",
  },
  primestay: {
    form_name: "Primestay",
    emailTempUser: "primestay_user",
    emailTempAdmin: "primestay_admin",
    emailSubjectUser: "Your recent enquiry - Primestay",
    emailSubjectAdmin: "Primestay",
    eventTracking: "Primestay",
  },
  financialInfo: {
    form_name: "Finiancial Info",
    emailTempUser: "financial_user",
    emailTempAdmin: "financial_admin",
    emailSubjectUser: "Your recent enquiry",
    emailSubjectAdmin: "Finiancial Info",
    eventTracking: "Finiancial Info",
  },
  registerInterest: {
    form_name: "Register Interest",
    emailTempUser: "register_interest_user",
    emailTempAdmin: "register_interest_admin",
    emailSubjectUser: "Your recent enquiry",
    emailSubjectAdmin: "Register Interest",
    eventTracking: "Register Interest",
  },
  contact: {
    form_name: "General Enquiry",
    emailTempUser: "contact_user",
    emailTempAdmin: "contact_admin",
    emailSubjectUser: "Your recent enquiry",
    emailSubjectAdmin: "General Enquiry",
    eventTracking: "General Enquiry",
  },
  bookViewing: {
    form_name: "Book a Viewing",
    emailTempUser: "book_viewing_user",
    emailTempAdmin: "book_viewing_admin",
    emailSubjectUser: " Your viewing request",
    emailSubjectAdmin: "Viewing Request",
    eventTracking: "Book a Viewing",
  },
  bookViewingMini: {
    form_name: "Book a Viewing",
    emailTempUser: "book_viewing_mini_user",
    emailTempAdmin: "book_viewing_mini_admin",
    emailSubjectUser: " Your viewing request",
    emailSubjectAdmin: "Viewing Request",
    eventTracking: "Book a Viewing",
  },
  listProperty: {
    form_name: "List Your Property",
    emailTempUser: "list_property_user",
    emailTempAdmin: "list_property_admin",
    emailSubjectUser: "List Your Property",
    emailSubjectAdmin: "List Your Property",
    eventTracking: "List Your Property",
  },
  sendCV: {
    form_name: "Job application",
    emailTempUser: "send_cv_user",
    emailTempAdmin: "send_cv_admin",
    emailSubjectUser: "Your job application",
    emailSubjectAdmin: "Job application",
    eventTracking: "Job application",
  },
  offMarket: {
    form_name: "Off-Market Enquiry",
    emailTempUser: "off_market_user",
    emailTempAdmin: "off_market_admin",
    emailSubjectUser: "Your Off-Market Enquiry",
    emailSubjectAdmin: "Off-Market Enquiry",
    eventTracking: "Off-Market Enquiry",
  },
  ifx_calculator: {
    form_name: "IFX Enquiry",
    emailTempUser: "ifx_user",
    emailTempAdmin: "ifx_admin",
    emailSubjectUser: "Your recent IFX enquiry",
    emailSubjectAdmin: "IFX Enquiry",
    eventTracking: "IFX Enquiry",
  },
  questionnaire: {
    form_name: "Questionnaire",
    emailTempUser: "questionnaire_user",
    emailTempAdmin: "questionnaire_admin",
    emailSubjectUser: "Your recent Questionnaire",
    emailSubjectAdmin: "Questionnaire",
    eventTracking: "Questionnaire",
  },
}

export const SUCCESS_MSG =
  "Thank you for contacting us. A member of our team will contact you shortly."

export const SUCCESS_MSG_DOWNLOAD = "Thank you for the download report."

export default FORM_CONFIG
